import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import { getWidthInPixels } from '@wix/editor-elements-common-utils';
import { ariaLabels, TranslationKeys } from '../constants';

// TODO add types
const props = withCompInfo<any, any>()(
  [
    'compData',
    'compProps',
    'compLayout',
    'compSingleLayout',
    'isOneDocMigrated',
    'compStylableClass',
    'translate',
  ],
  ({
    compData,
    compProps,
    compLayout,
    compSingleLayout,
    isOneDocMigrated,
    compStylableClass,
    translate,
  }) => {
    const widthInPixels = isOneDocMigrated
      ? getWidthInPixels(compSingleLayout)
      : compLayout.width;

    return {
      ...compData,
      ...compProps,
      stylableClassName: compStylableClass,
      width: widthInPixels,
      translations: {
        minValueAriaLabel:
          translate(
            ariaLabels.ariaNamespace,
            TranslationKeys.minValueAriaLabel,
          ) || ariaLabels.ariaDefaultMinValueLabel,
        maxValueAriaLabel:
          translate(
            ariaLabels.ariaNamespace,
            TranslationKeys.maxValueAriaLabel,
          ) || ariaLabels.ariaDefaultMaxValueLabel,
      },
    };
  },
);

export default createComponentMapperModel({
  props,
});
